module.exports = __webpack_public_path__ + "static/img/empty-folder.59aecfef.png";